var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.fieldClass, _vm.fieldName] },
    [
      _c("div", { attrs: { id: _vm.fieldName } }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "floating req",
          class: [{ "is-active": _vm.isActive }],
          attrs: { for: _vm.fieldName },
          on: { click: _vm.onFocus },
        },
        [_vm._v(_vm._s(_vm.fieldLabel))]
      ),
      _vm._v(" "),
      _vm.errors.length > 0 && _vm.showErrors
        ? _c("span", { staticClass: "field-validation-error" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.getValidationForField(_vm.errors[0])) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }